export default {
  app: {
    title: 'Overpass Planner',
    labs: 'LABS',
  },
  toolbar: {
    layers: 'Camadas',
    filters: 'Filtros',
    monitoredAreas: 'Áreas monitoradas',
    settings: 'Configurações',
  },
  layers: {
    baseMaps: 'Mapas base',
    cloudLayers: 'Camadas de nuvens',
    eumetsatTrueRgb: 'EUMETSAT True RGB',
    eumetsatIr: 'EUMETSAT IR 10.8',
    opacity: 'Opacidade',
    overlays: 'Sobreposições',
    satelliteOverpasses: 'Sobrevoos de satélites',
    aoiCoverage: 'Cobertura ADI',
    hexGrid: 'Grade hexagonal (Próximo sobrevoo)',
  },
  filters: {
    title: 'Filtros',
    savePreset: 'Salvar predefinição',
    deletePreset: 'Excluir predefinição',
    info: 'Info',
    preset: 'Predefinição',
    cloudCoverForecast: 'Previsão de cobertura de nuvens',
    cloudCoverDescription: 'Ocultar sobrevoos com previsão de cobertura de nuvens acima deste limite.',
    satellites: 'Satélites',
    satellitesFilter: 'Filtrar por satélite',
    satellitesDescription: 'Satélites agrupados por tipo de sensor.',
    selectAll: 'Selecionar tudo',
    deselectAll: 'Desmarcar tudo',
    ororaTechSafire: 'OroraTech SAFIRE',
    showGrouped: 'Mostrar agrupado',
    showIndividual: 'Mostrar individuais',
    predicted: 'Trajetória orbital',
    scheduled: 'Agendado',
    scheduledOnlyNote: 'As aquisições agendadas são janelas de tarefas confirmadas, disponíveis apenas para as próximas 48 horas. A trajetória orbital é prevista e cobre todo o intervalo.',
    retired: 'aposentado',
    backup: 'reserva',
    allSatellites: 'Todos os satélites',
    customPreset: 'Predefinição personalizada',
    manual: 'Manual',
    selectedOfTotal: '{selected} de {total} selecionados',
  },
  monitor: {
    title: 'Monitor',
    addArea: 'Adicionar área',
    dropzoneTitle: 'Arraste e solte arquivos GeoJSON aqui',
    dropzoneSubtitle: 'ou clique para procurar',
    dropzoneHint: '.geojson ou .json — máx. 5 MB por arquivo',
    dropFiles: 'Soltar para enviar',
    noAreasYet: 'Nenhuma área monitorada ainda',
    noAreasDescription: 'Selecione uma ADI no menu suspenso e clique em {action} para calcular a cobertura.',
    compute: 'Calcular',
    name: 'Nome',
    overpasses: 'Sobrevoos',
    calculated: 'Calculado',
    computing: 'Calculando...',
    area: 'Área',
    export: 'Exportar',
    delete: 'Excluir',
    clickToPan: 'Clique para centralizar, duplo clique para renomear',
    selected: '{count} selecionado(s)',
  },
  list: {
    title: 'Lista de sobrevoos',
    satellite: 'Satélite',
    direction: 'Direção',
    start: 'Início',
    end: 'Fim',
    sensor: 'Sensor',
    resolution: 'Resolução',
    light: 'Luz',
    cloud: 'Nuvens',
    latency: 'Latência',
    delivery: 'Entrega',
    loading: 'Carregando dados do satélite...',
    zoomIn: 'Aproxime para ver sobrevoos individuais.',
    noOverpasses: 'Nenhum sobrevoo visível com os filtros atuais.',
    uploadAoiToView: 'Carregue uma área de interesse para ver os dados de sobrevoo.',
    selectGridCell: 'Selecione uma célula da grade para ver os dados de sobrevoo.',
    day: 'dia',
    night: 'noite',
    close: 'Fechar',
    maxCloudCover: 'Cobertura de nuvens máx: {value}%',
  },
  popup: {
    start: 'Início',
    end: 'Fim',
    direction: 'Direção',
    ascending: 'Ascendente',
    descending: 'Descendente',
    sensor: 'Sensor',
    resolution: 'Resolução',
    constellation: 'Constelação',
    daylight: 'Luz do dia',
    day: 'Dia',
    night: 'Noite',
    dayEmoji: '☀ Dia',
    nightEmoji: '🌙 Noite',
    cloudCoverForecast: 'Previsão de cobertura de nuvens',
    cloudCoverObserved: 'Cobertura de nuvens (observada)',
    notCalculated: 'Não calculada',
    expectedLatency: 'Latência esperada',
    expectedDelivery: 'Entrega esperada',
    from: 'De',
    to: 'Até',
    coverage: '{pct}% Cobertura',
    areaCovered: 'Área coberta',
  },
  timeline: {
    title: 'Gráfico de linha do tempo',
    coveragePct: 'Cobertura %',
    allSatellites: 'Todos os satélites',
    bySatellite: 'Por satélite',
    bySensor: 'Por sensor',
    restore: 'Restaurar',
    maximize: 'Maximizar',
    close: 'Fechar',
    uploadAoiTimeline: 'Carregue uma área de interesse para ver a linha do tempo.',
    selectGridTimeline: 'Selecione uma célula da grade para ver a linha do tempo.',
  },
  hexLegend: {
    title: 'Tempo até o próximo sobrevoo',
    expandLegend: 'Expandir legenda',
    collapseLegend: 'Recolher legenda',
    noOverpasses: 'Sem sobrevoos nas próximas {hours} horas',
    notComputed: 'Não calculado para este período',
    coveragePast: 'A grade é pré-calculada a partir da última compilação — passagens anteriores não estão disponíveis aqui. Use a vista de faixas ou ADI para datas passadas.',
    coverageOtOnly: 'Após {date} a grade cobre apenas a constelação OroraTech.',
    coverageBeyondAll: 'A grade termina em {date}. Nada é pré-calculado além disso.',
    cellsSelected: '{count} célula(s) selecionada(s)',
    clear: 'Limpar',
  },
  hexTooltip: {
    nextOverpass: 'Próximo sobrevoo',
    satellite: 'Satélite',
    acquisition: 'Hora de aquisição',
    cloudForecast: 'Previsão de nuvens',
    status: 'Status',
    noOverpass: 'Sem sobrevoo na janela selecionada',
    timeIn: 'Em',
    totalPasses: 'Total de passagens',
  },
  settings: {
    language: 'Idioma',
    theme: 'Tema',
    light: 'Claro',
    dark: 'Escuro',
    timezone: 'Fuso horário',
    local: 'Local',
    colorblindFriendly: 'Cores adequadas para daltonismo',
  },
  timeControls: {
    start: 'Início',
    end: 'Fim',
    now: 'Agora',
    showGraph: 'Mostrar gráfico',
    hideGraph: 'Ocultar gráfico',
    showPanel: 'Mostrar painel',
    hidePanel: 'Ocultar painel',
    setStartToNow: 'Definir início para agora',
    resetTimeRange: 'Redefinir intervalo de tempo',
    gridCoverageHint: 'Pré-calculado: todos os satélites até {allSatellitesEnd}, apenas OroraTech até {end}. Sem datas passadas.',
  },
  viewToggle: {
    aoi: 'ADI',
    grid: 'Grade',
    swaths: 'Faixas',
    aoiTitle: 'Vista ADI — Mostrar apenas cobertura ADI',
    gridTitle: 'Vista grade — Tempo até o próximo sobrevoo',
    swathTitle: 'Vista de faixas',
  },
  geocoder: {
    searchPlaceholder: 'Buscar localização…',
    coordinates: 'Coordenadas',
    noResults: 'Sem resultados para',
    clearSearch: 'Limpar busca',
    trackGeolocation: 'Rastrear geolocalização',
    toggleGeolocation: 'Alternar geolocalização',
  },
  aoi: {
    selectOrUpload: 'Selecionar ou carregar ADI…',
    compute: 'Calcular',
    computing: 'Calculando…',
    uploadGeoJson: 'Carregar GeoJSON ADI',
    aoiLabel: 'ADI',
    clearAoi: 'Limpar ADI',
    uploadNew: 'Carregar novo GeoJSON…',
    computeCoverage: 'Calcular cobertura',
  },
  startup: {
    title: 'Comece com uma área de interesse',
    body: 'Carregue uma ADI para executar cálculos de cobertura, ou continue com a visão global.',
    dropzoneTitle: 'Arraste e solte arquivos GeoJSON aqui',
    dropzoneSubtitle: 'ou clique para procurar',
    dropzoneHint: '.geojson ou .json — máx. 5 MB por arquivo',
    or: 'ou',
    uploadAoi: 'Carregar ADI',
    continueGlobal: 'Continuar para visão global',
  },
  common: {
    zoomInHint: 'Aproxime para ver as informações de sobrevoo de satélites',
    openOverpassList: 'Abrir lista de sobrevoos',
    cloudCoverForecast: 'Previsão de cobertura de nuvens',
    groupedConstellation: 'Constelação agrupada',
    individualSatellites: 'Satélites individuais',
  },
};
